import React, { useState } from 'react';
import showIconn from '../../assets/images/show.png';
import hideIconn from '../../assets/images/hide.png';
interface InputProps {
  variant?: string;
  attributes?: Record<string, any>;
  onClick?: () => void;
  className?: string;
  leftIcon?: string;
  rightIcon?: string;
  type?: string;
  showPasswordToggle?: boolean;
  showIcon?: string;
  hideIcon?: string;
}

export const Input: React.FC<InputProps> = ({
  variant,
  attributes,
  onClick,
  className,
  leftIcon,
  rightIcon,
  type = 'text',
  showPasswordToggle = false,
  showIcon = showIconn,
  hideIcon = hideIconn,
}) => {
  // Initialize password visibility based on whether it's a password field
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [inputType, setInputType] = useState(type === 'password' ? 'password' : type);

  const baseClasses = 'px-4 py-2 rounded-lg text-dark bg-light border border-grey_light transition-colors duration-300 font-sora w-full focus:outline-none focus:border-secondary';

  const togglePasswordVisibility = () => {
    const newVisibility = !isPasswordVisible;
    setIsPasswordVisible(newVisibility);
    // Show text when visible, hide with password type
    setInputType(newVisibility ? 'text' : 'password');
  };

  const variantClasses: Record<string, any> = {
    'filled': '',
  };

  return (
    <div className="relative flex items-center w-full">
      {/* Left Icon */}
      {leftIcon && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 z-10">
          <img
            src={leftIcon}
            alt=""
            className="w-5 h-5"
            onError={(e) => {
              console.error('Left icon failed to load:', leftIcon);
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}

      {/* Input Field */}
      <input
        type={inputType == "password" ? (isPasswordVisible ? "text" : inputType) : inputType}
        className={`${baseClasses} ${variant && variantClasses[variant] || ''} ${className} ${leftIcon ? 'pl-10' : ''
          } ${(rightIcon || showPasswordToggle) ? 'pr-10' : ''
          }`}
        onClick={onClick}
        {...attributes}
      />

      {/* Right Icon or Password Toggle */}
      {(rightIcon || showPasswordToggle) && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 z-10">
          {showPasswordToggle ? (
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="focus:outline-none"
              aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
            >
              <img
                src={isPasswordVisible ? showIcon : hideIcon}
                alt={isPasswordVisible ? 'Hide password' : 'Show password'}
                className="w-5 h-5"
                onError={(e) => {
                  console.error('Password toggle icon failed to load');
                  e.currentTarget.style.display = 'none';
                }}
              />
            </button>
          ) : (
            <img
              src={rightIcon}
              alt=""
              className="w-5 h-5"
              onError={(e) => {
                console.error('Right icon failed to load:', rightIcon);
                e.currentTarget.style.display = 'none';
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Input;